import { render, staticRenderFns } from "./WebPasswordResetPopup.vue?vue&type=template&id=18d25e07&"
import script from "./WebPasswordResetPopup.vue?vue&type=script&lang=js&"
export * from "./WebPasswordResetPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports